import { mande } from 'mande'

const API_BASE = process.env.NODE_ENV === 'development' ? process.env.API_BASE : 'https://app.zacznijzsiwa.pl/api'

const API = Object.freeze({
  REGISTER_NEW_USER: `${API_BASE}/register`,
  CREATE_PAYMENT: `${API_BASE}/payment`
})

export const registerNewUser = async (newUserDetails) => await mande(API.REGISTER_NEW_USER).post(newUserDetails)
export const createPayment = async (paymentDetails) => await mande(API.CREATE_PAYMENT).post(paymentDetails)
